import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';
import Flex from '@decisiv/ui-components/lib/components/Flex';

export const Dropzone = styled(Flex)`
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 2px dashed ${toColorString(color.base.alaskanHusky)};
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  background-color: ${toColorString(color.base.fullMoon)};
`;

export const ResultRow = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid ${toColorString(color.base.halfMoon)};

  &:last-child {
    border-bottom: none;
  }
`;
